import { request, queryString } from '../../../shared/api/httpClient';
import { addDays, startOfStoreDay } from '../../../shared/lib/format';
export type PaymentMethod = 'cash' | 'transfer' | 'card';
export interface InvoiceLine { title: string; qty: number; amount: number; unit_price?: number; discount_amount?: number; ref_id?: string; kind?: 'service' | 'retail'; category_title?: string; employee_id?: string; employee_name?: string; description?: string }
export interface Invoice {
  id: string; customer_name: string; customer_id: string | null; employee_name: string; total: number;
  paid_amount: number; status: number; bill_date_ms: number;
  items: InvoiceLine[];
  store_id?: string; employee_id?: string; customer_phone?: string; payment_method?: PaymentMethod;
  note?: string; discount_amount?: number; tax_amount?: number; tax_mode?: 'none' | 'included' | 'added'; tax_rate?: number;
  appointment_id?: string | null; cash_tendered?: number; change_amount?: number; created_at?: number; paid_at?: number;
  employee_commission_amount?: number; employee_commission_percent?: number;
}
export const invoicesApi = {
  get: async (id: string, signal?: AbortSignal) => (await request<{ bill: Invoice }>('/bills/' + encodeURIComponent(id), { signal })).bill,
  list: async (from: string, to: string, timezone: string, signal?: AbortSignal) => {
    const records = new Map<string,Invoice>(); let page=1;
    for(;;){
      const result=await request<{bills:Invoice[];has_more:boolean;next_page:number|null;page:number}>('/bills'+queryString({from_ms:startOfStoreDay(from,timezone),to_ms:startOfStoreDay(addDays(to,1),timezone),limit:500,page}),{signal});
      if(!Array.isArray(result.bills)||typeof result.has_more!=='boolean'||result.page!==page)throw new Error('Chưa tải đủ dữ liệu. Hãy thử lại để xem danh sách và xuất báo cáo.');
      for(const invoice of result.bills){
        if(records.has(invoice.id))throw new Error('Chưa tải đủ dữ liệu. Hãy thử lại để xem danh sách và xuất báo cáo.');
        records.set(invoice.id,invoice);
      }
      if(!result.has_more)return [...records.values()];
      if(result.next_page!==page+1||!result.bills.length)throw new Error('Chưa tải đủ dữ liệu. Hãy thử lại để xem danh sách và xuất báo cáo.');
      page=result.next_page;
    }
  },
};
